var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.pageType === _vm.orderPageTypeName ||
    _vm.pageType === _vm.salesPageTypeName ||
    _vm.pageType === _vm.stockMovePageTypeName ||
    _vm.pageType === _vm.stockAdjustPageTypeName
  )?_c('div',{staticClass:"productTableCom"},[_c('v-data-table',{staticClass:"rounded-lg",attrs:{"headers":_vm.headers,"items":_vm.items,"item-key":_vm.itemKey,"hide-default-header":false,"hide-default-footer":"","items-per-page":-1,"no-data-text":_vm.$t('common.common_no-history')},scopedSlots:_vm._u([{key:"item.changeAt",fn:function(ref){
  var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getDateFromDateTimeString(item.changeAt))+" ")]}},{key:"item.beforeStatusId",fn:function(ref){
  var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getBeforeStatusList(item.beforeStatusId))+" ")]}},{key:"item.afterStatusId",fn:function(ref){
  var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getAfterStatusList(item.afterStatusId))+" ")]}},{key:"item.userId",fn:function(ref){
  var item = ref.item;
return [_vm._v(" "+_vm._s(item.user.lastName + item.user.firstName)+" ")]}}],null,true)})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }